
import './DriverEdit.css'
import Modal from 'react-bootstrap/Modal';
import './ModalCreateEventForm.css'
import fetchData from '../../../function/fetchData';
import Container from 'react-bootstrap/Container';


import React from 'react'

const DriverEdit = ({server, token, onShow, onHide, drivers, fetchDataFromServer}) => {
    const serveAddress = server + '/api2/adminDriverController.php';

    // Delete one
    const handleChangeRank = ( driverId, rank ) => {
        fetchData(serveAddress , {token: token, action: 'SET_RANK', driverId: driverId, rank: rank})
        .then( (res) => {
            console.log(res)
            if(res.status === 'OK'){
                fetchDataFromServer()
            } else {
                alert('Chyba spojení, zkuste to prosím později.')
            }
        })
        
    };

    const selected =  { paddingLeft: 8, color: 'grey', border: '1px solid grey' , borderRadius: 10, cursor: 'pointer'}
    const unSelected = {paddingLeft: 8 , cursor: 'pointer'}

    return (
        <>
        <Modal
            size="lg"
            show={onShow}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    Řidiči a jejich status
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Container style={{display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center'}}>
                {drivers && drivers.map( one => {
                    const rank = parseInt(one.rank)
                    return <div key={one.id} style={{display: 'flex', alignItems: 'center', marginTop: 24, gap: 8, background: '#eee', padding: 8, borderRadius: 10, minWidth:220}}>
                                <img src={one.img} style={{width: 70}}/>
                                <div className='textContent'>
                                    <h3>{one.nick}</h3>
                                    <p style={rank === 1 ? selected : unSelected } onClick={()=>handleChangeRank(one.id, 1)}>Gold</p>
                                    <p style={rank === 2 ? selected : unSelected } onClick={()=>handleChangeRank(one.id, 2)}>Silver</p>
                                    <p style={rank === 3 ? selected : unSelected } onClick={()=>handleChangeRank(one.id, 3)}>Bronz</p>
                                </div>
                               
                            </div>
                })}
            </Container>  
            </Modal.Body>
        </Modal>
        </>
    )
}

export default DriverEdit
